<template>
  <tr class="clickable">
    <td>
      {{ staff.name }}
    </td>
    <td>
      {{ staff.contact_details.email || staff.user.email }}
    </td>
    <td>
      {{ staff.contact_details.phone }}
    </td>
    <td>
      <div
        v-for="role in staff.user.roles"
        :key="role.id"
      >
        {{ role.title }}
      </div>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'StaffRow',
    props: {
      staff: {
        type: Object,
        default: null
      }
    }
  }
</script>
